import connectToStores from 'alt-utils/lib/connectToStores'
import InstalledDialog from '../components/plus/InstalledDialog'
import FailedDialog from '../components/plus/FailedDialog'
import { ResponsiveDialog  } from 'common-frontend'
import { SEOSettingsActions, SERPPreviewActions, PlusActions, ShopDetailsActions } from 'actions'
import { SEOSettingsStore, SERPPreviewStore, PlusStore, ShopDetailsStore } from 'stores'
import Helmet from 'react-helmet'
import { Button, HelpEmail, Nav, Loading, EditTitleDescriptionTemplate, EditOtherSettings } from 'components'

@connectToStores
export default class SEOSettingsContainer extends React.Component {
  static contextTypes = {
    currentUser: React.PropTypes.object
  }

  static propTypes = {
    params: React.PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    if (!props.settings) {
      SEOSettingsActions.fetch()
    }
    if (!props.shopDetails) {
      ShopDetailsActions.fetch()
    }

    this.state = { showFailedDialog: false, showInstalledDialog: false }
  }

  static getStores() {
    return [SEOSettingsStore, SERPPreviewStore, PlusStore, ShopDetailsStore]
  }

  componentWillReceiveProps(props) {
    if (props.failed) {
      this.setState({ showFailedDialog: true })
    } else if (props.installed) {
      this.setState({ showInstalledDialog: true })
    }
  }

  handleRequestInstall(showRequestedManualInstallDialog = false) {
    PlusActions.requestPlusInstall(this.context.currentUser)
    PlusActions.fetch()

    if (showRequestedManualInstallDialog) {
      this.setState({ showRequestedManualInstallDialog: true })
    }
  }

  handleSelfInstall() {
    PlusActions.selfInstall()
    PlusActions.fetch()
  }

  maybeShowFailedDialog() {
    return this.state.showFailedDialog && <FailedDialog/>
  }

  maybeShowInstalledDialog() {
    return this.state.showInstalledDialog &&
      <InstalledDialog installed={this.props.installed}
        upgrade={this.props.isUpgrade}
        hasInclude={this.props.status.hasInclude}
        handleRequestInstall={::this.handleRequestInstall}
        handleSelfInstall={::this.handleSelfInstall} />
  }

  // Only used when requesting via the preview
  maybeShowRequestManualInstallRequestedDialog() {
    return this.state.showRequestedManualInstallDialog &&
      (
        <ResponsiveDialog
          title="Your Request is Sent"
          maxWidth="600px"
          modal={true}
          open={true}
          onRequestClose={() => this.setState({ showRequestedManualInstallDialog: false })}
        >
          <div>
            <div className="large-spacing2">
              <p>One of our team members will email you within 24 hours to help you add this last piece of Plug in SEO code to your theme.</p>
              <p className="medium-spacing--top">Need any more help? Email us at <HelpEmail/></p>
            </div>

            <Button label="Close"
              buttonType="secondary"
              onTouchTap={() => this.setState({ showRequestedManualInstallDialog: false })} />
          </div>
        </ResponsiveDialog>
      )
  }

  componentWillMount() {
    PlusActions.fetch()
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState(),
      ...SERPPreviewStore.getState(),
      ...PlusStore.getState(),
      ...ShopDetailsStore.getState()
    }
  }

  render() {
    if (!this.props.settings) {
      return (
        <div>
          <Helmet title={`Loading...`} />
          <Nav toolbarTitleText={`Loading...`} />
        </div>
      )
    }

    const resource = this.props.params.resource
    if (['appender','structured-data','advanced'].indexOf(resource) > -1) {
      return (
        <EditOtherSettings
          params={this.props.params}
          settings={this.props.settings}
          fetching={this.props.fetching}
          shopDetails={this.props.shopDetails}
          noShopDetails={this.props.noShopDetails}
        />
      )
    } else {
      return (
        <div>
          <EditTitleDescriptionTemplate
            params={this.props.params}
            settings={this.props.settings}
            fetching={this.props.fetching}
            previews={this.props.previews}
            fetchingPreviews={this.props.fetchingPreviews}
            installed={this.props.status.installed}
            isInstalling={this.props.isInstalling}
            failed={this.props.failed}
            status={this.props.status}
            currentUser={this.context.currentUser}
            handleRequestInstall={() => { this.handleRequestInstall(true) }}
          />

        { this.maybeShowInstalledDialog() }
        { this.maybeShowFailedDialog() }
        { this.maybeShowRequestManualInstallRequestedDialog() }
      </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./app/containers/SEOSettingsContainer.js